import StatusesModel from '#model/StatusesModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class StatusesViewModel {

  constructor(apiClient, notificationsProvider) {
    this.model = new StatusesModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new StatusesModel.Status()
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getStatuses()
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    this.entity = new StatusesModel.Status(entity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createStatus(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateStatus(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this entity?')) {
      try {
        const result = await this.model.deleteStatus(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'status_id', label: "ID", _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'name', _style: { width: '25%'} },
      { key: 'description' },
      {
        key: 'actions',
        label: '',
        _style: { width: '70px' },
        filter: false
      }
    ]
  }

}

StatusesViewModel.useInstance = function() {
  return useInstanceOf(StatusesViewModel, useApiClient(), useNotifications())
}
